import React, { useEffect, useState } from 'react'
import styles from './style.module.css'
import { UploadFileAndList, IndirectPaymentUpload } from '../../../Components'
import exampleFile from './exampleimportacao.xlsx'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import pastDueImage from '../../../assets/images/past-dues-image.svg';
import HeaderInternal from '../../../Components/HeaderInternal';
import { getFeatureFlags } from '../../../services/kollectaApi';

const INDIRECT_PAYMENT_IMPORT_KEY = 'indirect_payment_import';

const PastDue = () => {
  const [hasIndirectPaymentImport, setHasIndirectPaymentImport] = useState(false);

  useEffect(() => {
    const loadFeatureFlags = async () => {
      try {
        const response = await getFeatureFlags();
        const flags = response?.data?.featureFlags || [];
        const enabled = flags.some(
          (flag) => flag.key === INDIRECT_PAYMENT_IMPORT_KEY && flag.enabled
        );
        setHasIndirectPaymentImport(enabled);
      } catch (error) {
        setHasIndirectPaymentImport(false);
      }
    };

    loadFeatureFlags();
  }, []);

  return (
    <div className={styles.container}>
      <ReactCSSTransitionGroup transitionName="anim"
        transitionAppear={true}
        transitionAppearTimeout={500}
        transitionEnter={false}
        transitionLeave={false}>
        <section>
          <HeaderInternal title="Importação de dados" bold={true} />
          <div className={styles.paddingContent}>
            <div className={styles.infoCustomer}>
              <h4 className={styles.subtitlePastDueDashCustomer}>Olá, {localStorage.getItem('user.name')}</h4>
              <h5 className={styles.smallMargin}>
                Por aqui você faz o upload do arquivo em Excel com as informações das dívidas que ficarão cadastradas no sistema.
              </h5>

              <h5>
                Caso tenha dúvidas sobre o formato do arquivo, <a target="_blank" rel="noreferrer" href={exampleFile}>clique neste link</a> onde terá acesso ao modelo.
              </h5>
            </div>

            <div className={styles.uploadDocument}>
              <div className={styles.uploadDocumentContent}>
                <div className={styles.imageContainer}>
                  <img src={pastDueImage} alt="Pessoa cadastrando dívidas no painel" />
                </div>
                <UploadFileAndList showList />
              </div>
            </div>

            {hasIndirectPaymentImport && (
              <div className={styles.statusUpdateSection}>
                <div className={styles.statusUpdateBadge}>Atualização de status</div>
                <h3 className={styles.statusUpdateTitle}>Pagamento indireto</h3>
                <p className={styles.statusUpdateDescription}>
                  Esta área <strong>não importa novas dívidas</strong>. Use uma planilha com a coluna
                  <strong> cpf_ou_cnpj </strong>
                  para atualizar o status de todas as dívidas desses documentos para
                  <strong> Pagamento indireto</strong>.
                </p>

                <div className={styles.uploadDocument}>
                  <div className={styles.uploadDocumentContent}>
                    <IndirectPaymentUpload />
                  </div>
                </div>
              </div>
            )}
          </div>
        </section>
      </ReactCSSTransitionGroup>
    </div>
  )
}

export default PastDue
